// Bascule entre les panneaux de sinistre d'une section de solution. Le premier panneau est déjà
// ouvert côté serveur : sans JS, la page reste lisible avec le sinistre principal affiché.
export default class SolutionDisasters {
	constructor() {
		document.querySelectorAll("[data-solution-disasters]").forEach((group) => {
			const buttons = [...group.querySelectorAll("[data-solution-disaster-value]")];
			const panels = [...group.querySelectorAll("[data-solution-disaster-panel]")];
			if (buttons.length < 2 || !panels.length) return;

			buttons.forEach((button) => {
				button.addEventListener("click", () => {
					const value = button.dataset.solutionDisasterValue;

					buttons.forEach((item) => {
						const isCurrent = item === button;
						item.classList.toggle("active", isCurrent);
						item.setAttribute("aria-pressed", isCurrent ? "true" : "false");
					});

					panels.forEach((panel) => {
						panel.hidden = panel.dataset.solutionDisasterPanel !== value;
					});
				});
			});
		});
	}
}
